import { createStore, applyMiddleware, Store } from 'redux';
import thunk from 'redux-thunk';
import reducer from '../reducers/reducer';
import { MenuState, MenuStateAction, DispatchType } from '../types';

export const store: Store<MenuState, MenuStateAction> & {
  dispatch: DispatchType;
} = createStore(reducer, applyMiddleware(thunk));
